import React, { useState } from "react";
import Cookies from "universal-cookie";
import ReactDOMServer from "react-dom/server";
import { Buffer } from 'buffer';

const Alice = (props) => {
    const cookies = new Cookies();
    const enc = Buffer.from(
        ReactDOMServer.renderToStaticMarkup(props.children)
    ).toString("base64");
    const [show, setShow] = useState(
        cookies.get(`alice-${enc.length}`) === undefined
    );

    const closeCookie = () => {
        cookies.set(`alice-${enc.length}`, "no", { path: "/" });
        setShow(false);
    };
    const openCookie = () => {
        cookies.remove(`alice-${enc.length}`, { path: "/" });
        setShow(true);
    };

    const render = (mode) => {
        return <div className="d-center h-100">
            <div className="mx-auto d-center flex-column h-100">
                <div className="d-center w-350">
                    <span><img className="me-3" alt="Codeless ONE AI - Alice" src={`${process.env.REACT_APP_DATALAKESTORAGE_URL}/${process.env.REACT_APP_DATALAKESTORAGE_RESOURCES}/images/alice.svg`} width={75} /></span>
                    <div className="header flex-grow-1">
                        {props.header}
                    </div>
                </div>
                <div className="m-3 ps-2 d-block w-350">
                    {props.children}
                </div>
            </div>
        </div>

        if (mode === "mini") {
            return show ? (
                <div className="p-3 mx-auto mt-5 border rounded alice d-flex justify-content-center align-items-end w-50 position-relative">
                    <div className="ps-4">{props.children}</div>

                    <img
                        alt="Codeless ONE AI - Alice"
                        src={`${process.env.REACT_APP_DATALAKESTORAGE_URL}/${process.env.REACT_APP_DATALAKESTORAGE_RESOURCES}/images/alice.svg`}
                        width={75}
                        className="position-absolute rounded-circle alice-circle"
                        style={{ left: -35, top: -35 }}
                    />
                    <i
                        className="top-0 right-0 m-2 fa fa-times position-absolute pointer"
                        onClick={() => closeCookie()}
                    ></i>
                </div>
            ) : (
                <div className="top-0 right-0 position-absolute">
                    <img
                        alt="Codeless ONE AI - Alice"
                        src={`${process.env.REACT_APP_DATALAKESTORAGE_URL}/${process.env.REACT_APP_DATALAKESTORAGE_RESOURCES}/images/alice.svg`}
                        width={25}
                        className="rounded-circle pointer"
                        onClick={() => openCookie()}
                    />
                </div>
            );
        } else if (mode === "box")
            return (
                <div className="p-2 mx-auto border d-flex w-50">
                    <img
                        className="mx-4"
                        alt="Codeless ONE AI - Alice"
                        src={`${process.env.REACT_APP_DATALAKESTORAGE_URL}/${process.env.REACT_APP_DATALAKESTORAGE_RESOURCES}/images/alice.svg`}
                        width={75}
                    />
                    <div className="pt-2">{props.children}</div>
                </div>
            );
        else if (mode === "new")
            return (
                <>
                    <div className="mx-auto d-center flex-column h-100" style={{ width: 350 }}>
                        <div className="d-center">
                            <img className="me-4" alt="Codeless ONE AI - Alice" src={`${process.env.REACT_APP_DATALAKESTORAGE_URL}/${process.env.REACT_APP_DATALAKESTORAGE_RESOURCES}/images/alice.svg`} width={75} />
                            <div className="header">{props.header} </div>
                        </div>
                        <div className="p-3 m-3 d-block text-justify">
                            {props.children}
                        </div>
                    </div>
                </>
            );
        else
            return (
                <div
                    className={
                        props.nowrap === undefined &&
                        `d-flex flex-column justify-content-center align-items-center h-100`
                    }
                >
                    <div className="mt-5 alice d-flex justify-content-center align-items-end">
                        <div className="pe-4">
                            <img alt="Codeless ONE AI - Alice" src={`${process.env.REACT_APP_DATALAKESTORAGE_URL}/${process.env.REACT_APP_DATALAKESTORAGE_RESOURCES}/images/alice.svg`} height={80} />
                        </div>
                        <div>
                            <div className="p-4 border rounded alice-content">
                                {props.children}
                            </div>
                        </div>
                    </div>
                </div>
            );
    };

    return render(props.mode);
};
export default Alice;
